import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'payment_method';

export default {
  async search() {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.get(url);
  },
  async create(body) {
    const url = mountUrl(`/${BASE_PATH}`);
    return api.post(url, body);
  },
  async update(id, body) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.patch(url, body);
  },
  async inactivate(id) {
    const url = mountUrl(`/${BASE_PATH}/${id}`);
    return api.delete(url);
  }
};
